import { DropDownWithLabelModel } from "../dropDown";

export enum TypeOfActivityId {
  registered = "REGISTERED",
  services = "SERVICES",
  retailTrade = "RETAIL_TRADE",
  agricultural = "AGRICULTURAL",
  wholesaleTrade = "WHOLESALE_TRADE",
  production = "PRODUCTION",
  tradeInflammableSubstances = "TRADE_INFLAMMABLE_SUBSTANCES",
  vehicleSales = "VEHICLE_SALES",
  workshop = "WORKSHOP",
  other = "OTHER"
}

export const TypeOfActivityDropDown: DropDownWithLabelModel = {
  label: "Rodzaj działalności",
  dropDown: [
    {
      id: TypeOfActivityId.registered,
      displayName: "Biuro lub działalność jest tylko zarejestrowana"
    },
    {
      id: TypeOfActivityId.services,
      displayName: "Usługi"
    },
    {
      id: TypeOfActivityId.retailTrade,
      displayName: "Drobny handel detaliczny"
    },
    {
      id: TypeOfActivityId.agricultural,
      displayName: "Rolnicza"
    },
    {
      id: TypeOfActivityId.wholesaleTrade,
      displayName: "Handel hurtowy"
    },
    {
      id: TypeOfActivityId.production,
      displayName: "Produkcja"
    },
    {
      id: TypeOfActivityId.tradeInflammableSubstances,
      displayName: "Handel chemikaliami, paliwami, farbami, lakierami"
    },
    {
      id: TypeOfActivityId.vehicleSales,
      displayName: "Sprzedaż pojazdów"
    },
    {
      id: TypeOfActivityId.workshop,
      displayName: "Warsztat lakierniczy, spawalniczy, stolarski, tapicerski, samochodowy"
    },
    {
      id: TypeOfActivityId.other,
      displayName: "Inna"
    }
  ]
};

